module.exports = __webpack_public_path__ + "static/media/mj-20191011.b7eadab8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/mj-20191011.jpg
// module id = 72
// module chunks = 0